let config = {};
const subdomain = window.location.hostname.replace(/(.*)\.bubbleplan\.net/i, '$1');
if (['localhost', 'wpd', 'univlyon3', 'mel', 'metro', 'puic', 'leroymerlin', 'horis', 'dgddi-di-idf'].includes(subdomain)) {
  config = require(`./${subdomain}`);
  config = config.default || config;
}

const integration = decodeURIComponent(window.location.search.replace(new RegExp("^(?:.*[&\\?]integration(?:\\=([^&]*))?)?.*$", "i"), "$1"));
if (integration == 'microsoftteams') {
  config = angular.merge({}, require(`./integrations/microsoftteams`).default, config);
}

export default config;
